import moment from 'moment';
import { CacheableDataObject } from 'models/CacheableDataObject';
import { DateFormat } from './DateFormat';
import { Character } from 'models/Character.jsx';


export default class UserChatRoom extends CacheableDataObject {

	isAdmin() {
		return !!this.is_chat_admin;
	}

	isMod() {
		return !!this.is_chat_mod || this.isAdmin();
	}

	/** The user's main for this room's game (a Character), or null. */
	getMain() {
		return this.main || null;
	}

	/** Whether the user has an open search that counts for this room. */
	isSearching() {
		return !!this.is_searching;
	}

	get muted() {
		return this._muted && this._muted.isAfter(moment()) && this._muted;
	}

	get kicked() {
		return this._kicked && this._kicked.isAfter(moment()) && this._kicked;
	}
}

UserChatRoom.prototype.dataLocationParsers = {
	is_admin: (object, data) => {
		object.is_chat_admin = !!data.is_admin;
	},
	is_mod: (object, data) => {
		object.is_chat_mod = !!data.is_mod;
	},
	is_chat_admin: (object, data) => {
		object.is_chat_admin = !!data.is_chat_admin;
	},
	is_chat_mod: (object, data) => {
		object.is_chat_mod = !!data.is_chat_mod;
	},
	main: (room, data) => {
		room.main = data.main ? Character.create(data.main) : null;
	},
	is_searching: (room, data) => {
		room.is_searching = !!data.is_searching;
		room.searchingReportedAt = Date.now();
	},
	muted: (room, data) => {
		room._muted = DateFormat.momentFromLadderTime(data.muted);
	},
	kicked: (room, data) => {
		room._kicked = DateFormat.momentFromLadderTime(data.kicked);
	},
};